// src/components/QuestionComponent.js

import React, { useEffect, useState, useRef } from 'react';
import './QuestionComponent.css';
import { CircularProgressbar } from 'react-circular-progressbar';

import { faQuestionCircle, faInfoCircle, faTrophy, faLightbulb, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from './ProgressBar';
import BackgroundMusic from './BackgroundMusic';
const l = ['A','B','C','D']
function QuestionComponent({ question, mode,soundOn=false }) {
    const [showContent, setShowContent] = useState(false);
    const questionTextRef = useRef(null);
    const explanationTextRef = useRef(null);


    useEffect(() => {
        // Trigger fade-in when component mounts or mode changes to show question
        if (mode === 2 || mode === 3 || mode === 4) {
            setShowContent(true);
        } else {
            // Trigger fade-out when mode changes to hide question
            setShowContent(false);
        }
        if(mode==2)
        {     setText(question.question_text+'...is it.. A. ...'+ question.options[0]+'... B. ..'+ question.options[1]+'... C. ...'+ question.options[2]+'..or D. ...'+ question.options[3]);

        }else{
            setText('');
        }
        if(mode==4)
        {
            setText("The Answer is ... " + l[question.answerIndex]+'... ...' +question.options[question.answerIndex])
        }

    }, [mode]);
    const [fontSize, setFontSize] = useState(40);
    const [fontSizeE, setFontSizeE] = useState(40);
    const [text, setText] = useState('');
  
    useEffect(() => {
        if (!text.trim()) return;
        // Debounce: wait 300ms after the last change before speaking
        const timer = setTimeout(() => {
          window.speechSynthesis.cancel();
          const utterance = new SpeechSynthesisUtterance(text);
          utterance.rate = 0.8;
          utterance.volume=0.7;
          //if(soundOn)
          //  window.speechSynthesis.speak(utterance);
        }, 300);
    
        return () => clearTimeout(timer);
    }, [text]);

    // Function to calculate and adjust font size to fit container
    const adjustFontSize = (textElement, containerElement, initialSize, text, setSize) => {
        if (!containerElement || !textElement) return;
        
        const container = containerElement;
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        
        // Calculate reasonable max font size based on container dimensions
        // For small amounts of text, we don't want it to be too large
        const containerBasedMax = Math.min(containerWidth / 12, containerHeight / 2);
        
        // Set reasonable limits - never smaller than 16px or larger than 60px
        // Also consider text length for maximum size
        const maxSize = Math.min(
            50, 
            containerBasedMax,
            // For short text, limit maximum size further
            text.length < 20 ? 48 : 50
        );
        const minSize = 20;
        
        // Start with initial size
        let testSize = initialSize;
        textElement.style.fontSize = `${testSize}px`;
        
        // Reduce font size until text fits container
        while ((textElement.scrollWidth > containerWidth || textElement.scrollHeight > containerHeight) && testSize > minSize) {
            testSize -= 2;
            textElement.style.fontSize = `${testSize}px`;
        }
        
        // Increase font size until text no longer fits, but respect maximum size
        while (textElement.scrollWidth < containerWidth && textElement.scrollHeight < containerHeight && testSize < maxSize) {
            testSize += 2;
            textElement.style.fontSize = `${testSize}px`;
            
            // If we've exceeded container dimensions, back off by 2px
            if (textElement.scrollWidth > containerWidth || textElement.scrollHeight > containerHeight) {
                testSize -= 4;
                textElement.style.fontSize = `${testSize}px`;
                break;
            }
        }
        
        setSize(testSize);
    };

    useEffect(() => {
        if (mode === 2 || mode === 3) {
            // Wait for DOM to update
            const timer = setTimeout(() => {
                if (questionTextRef.current) {
                    const textElement = questionTextRef.current;
                    const containerElement = textElement.parentElement;
                    adjustFontSize(textElement, containerElement, 40, question.question_text, setFontSize);
                }
            }, 50);
            
            return () => clearTimeout(timer);
        }
    }, [question.question_text, mode, showContent]);
    
    useEffect(() => {
        if (mode === 4) {
            // Wait for DOM to update
            const timer = setTimeout(() => {
                if (explanationTextRef.current) {
                    const textElement = explanationTextRef.current;
                    const containerElement = textElement.parentElement;
                    adjustFontSize(textElement, containerElement, 40, question.explanation, setFontSizeE);
                }
            }, 50);
            
            return () => clearTimeout(timer);
        }
    }, [question.explanation, mode, showContent]);

    // Add resize listener
    useEffect(() => {
        const handleResize = () => {
            if (mode === 2 || mode === 3) {
                if (questionTextRef.current) {
                    const textElement = questionTextRef.current;
                    const containerElement = textElement.parentElement;
                    adjustFontSize(textElement, containerElement, fontSize, question.question_text, setFontSize);
                }
            }
            
            if (mode === 4) {
                if (explanationTextRef.current) {
                    const textElement = explanationTextRef.current;
                    const containerElement = textElement.parentElement;
                    adjustFontSize(textElement, containerElement, fontSizeE, question.explanation, setFontSizeE);
                }
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [fontSize, fontSizeE, mode, question]);

    return (
        <>
        <div className="question-component">
            <div className="content-container">
                {(mode === 3 || mode === 2) && <div className={`question-text ${showContent ? 'fade-in' : 'fade-out'}`}>
                    <h2 ref={questionTextRef} style={{ fontSize: `${fontSize}px` }}>{question.question_text}</h2>
                </div>}
  
                {(mode === 4) && <div className={`question-text  ${showContent ? 'fade-in' : 'fade-out'}`}>
                    <div style={{alignItems:'center',textAlign:'center',color:'#ffdd55'}}>
                        <h2 ref={explanationTextRef} style={{fontSize: `${fontSizeE}px`,color:'#ffdd55' }}>{'💡 ' + question.explanation}</h2>
                    </div>
                </div>}
                <div className="options">
                    {question.options.map((option, index) => (
                        <Option
                            key={index}
                            index={index}
                            optionLetter={String.fromCharCode(65 + index)}
                            optionText={option}
                            isCorrect={(mode === 3 || mode === 4) && index === question.answerIndex}
                            showContent={showContent}
                            mode={mode}
                        />
                    ))}
                </div>
            </div>
        </div></>
    );
}

function Option({ optionLetter, optionText, isCorrect, showContent, index,mode }) {
    return (
        <div
            className={`option ${isCorrect ? 'correct' :(mode==3 || mode==4) ?'wrong':''} ${showContent ? 'fade-in' : 'fade-out'}`}
            style={{ animationDelay: `${index * 0.3}s` }} // Adjust delay as needed
        >
            <div className="option-letter">
                <span>{optionLetter}</span>
            </div>
            <div className="option-text">
                <span>{optionText}</span>
            </div>
        </div>
    );
}

export default QuestionComponent;